export default __webpack_public_path__ + "static/media/Plugin-FirstBase.33afc0da.png";